// ia-credits.ts — Achat de crédits IA supplémentaires (popup « Mon compte »).
// L'achat donne lieu à facturation (l'IHM confirme avant l'appel).
import { req } from './_internals.js';

export const iaCreditsApi = {
  buyIaCredits: () => req('POST', '/me/ia-credits/buy'),
};
